<template>

   <div v-if="!isLoading" class="my-0 md:w-[50%] mx-auto ">
      <div v-if="data">
         <div ref="pdfContent">
            <Voucher :data="data" />
         </div>
         <div class="flex flex-row items-center gap-3 justify-end mt-4">
            <button @click="handleCancelBooking" type="button" class="rounded-md bg-theme-button5-bg px-2.5 py-1.5 text-sm font-semibold text-theme-button5-txt shadow-sm">
               Cancel Booking
            </button>
            <button v-if="showMakePaymentButton" @click="handleMakePayment" type="button" class="rounded-md bg-theme-button1-bg px-2.5 py-1.5 text-sm font-semibold text-theme-button1-txt shadow-sm">
               Make Payment
            </button>
            <button @click="downloadPDF" type="button" class="rounded-md bg-theme-button2-bg px-2.5 py-1.5 text-sm font-semibold text-theme-button2-txt shadow-sm">
               Download PDF
            </button>
         </div>
      </div>
      <div v-else class="text-center py-12 bg-white rounded-lg border border-gray-200 shadow-sm px-4">
         <h2 class="text-xl font-bold text-gray-900">Booking Not Found</h2>
         <p class="text-gray-500 mt-2 text-sm">The booking reference you requested could not be located.</p>
      </div>
   </div>
   <Modal :show="openConfirmModal" @closed="handleConfirmClose">
      <template v-slot:content>
         <div class="mt-8">
            To cancel this booking contact our support representative at bookings@vehitraworld.com
         </div>
      </template>
   </Modal>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import Voucher from '@/components/booking/Voucher.vue'
import { Booking } from '@/types'
import BookingService from '@/services/booking-service'
import { getSessionPrefix, isMakePaymentVisible, saveBookingNumber } from '@/utils/common'
import router from '@/router'
// @ts-ignore
import html2pdf from 'html2pdf.js'
import Modal from '@/widgets/Modal.vue'
import { saveUserSearch } from '@/services/search-service'
import CarService from '@/services/car-service'

const props = defineProps(['number'])
const data = ref<Booking | null>(null)
const isLoading = ref<boolean>(true)
const { readBooking } = BookingService()
const pdfContent = ref(null)
const openConfirmModal = ref<boolean>(false)
const showMakePaymentButton = ref<boolean>(false)
const { saveSelectedCar } = CarService()

onMounted(async () => {

   const response = await readBooking(props.number)
   isLoading.value = false
   
   if (response.success && response.data && response.data.data) {
      data.value = response.data.data
      if (data.value?.search?.pickUp?.date) {
         showMakePaymentButton.value = isMakePaymentVisible(data.value.search.pickUp.date)
      }
   } else {
      console.log(response.error)
   }
})

const downloadPDF = () => {
  const el = pdfContent.value as HTMLElement | null
  if (!el) return

  const filename =
    data.value?.number ? `User_Voucher_${data.value.number}.pdf` : 'User_Voucher.pdf'

  html2pdf()
    .set({
      filename,
      margin: [10, 10, 10, 10],
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: window.devicePixelRatio > 1 ? 2 : 1, useCORS: true },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
      pagebreak: { mode: ['css', 'legacy'] },
    })
    .from(el)
    .save()
}

const handleCancelBooking = () => {

   openConfirmModal.value = true
}

const handleMakePayment = () => {
   if (data.value) {
      saveUserSearch(data.value.search)
      saveBookingNumber(props.number)
      saveSelectedCar(data.value.car)
      router.push({name: 'BookingWizard', params: {step: 'contact-details'}})
   }
}

const handleConfirmClose = () => openConfirmModal.value = false

</script>